import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTextInput from "../../../../../CustomComponents/CustomtextInput";
import { useTranslation } from "react-i18next";
import CustomDropdown from "../../../../../CustomComponents/CustomDropDown";
import CustomDatePicker from "../../../../../CustomComponents/CustomDateInput";
import Calender from "../../../../../../assets/images/calender_3x.png";
import { handleAmountInputLimitTo2decimal } from "../../../../../../utils";
import { appTheme, decimalValidation } from "../../../../../../helpers/utils/Utils";
import CustomAllocateFundDropdown from "../../../../../CustomComponents/CustomAllocateFundDropdown";
import { useEffect } from "react";

const AllocateFundSubItemConfirmationCard = ({ data, onEdit, isActive, setIsEditingState }) => {
  const kudzuPlusTrue = useSelector((state) => state.kudzuPlusTrue);
  const savingsGoalAmount = useSelector((state) => state.savingGoals.Amount);


  console.log("savingTargetAmount", savingsGoalAmount)

  const appThemeData = appTheme(kudzuPlusTrue);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [editedValue, setEditedValue] = useState(data.value);
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState("");
  const errorMessages = {
    Amount: "Amount is required",
    Installments: "Installment is required", 
    Frequency: "Frequency  type is required", 
    Name: "Name is required", 
  };
  const frequecyDataGetting = useSelector((state) => state.frequecyData);
  const accountObj = useSelector((state) => state.accountTypes);
  const [selectedAccountType, setSelectedAccountType] = useState("");


   useEffect(() => {
      if (setIsEditingState) {
        setIsEditingState(isEditing);  // Pass the state directly to the parent component
      }
    }, [isEditing]);

  const handleSave = () => {
    debugger;
    if (!editedValue) {
      setError(errorMessages[data.type]);
    } else {
      setIsEditing(false);
      dispatch({
        type: "ALLOCATE_FUND",
        payload: { key: data.type, value: editedValue },
      });
      if (data.type == "Name") {
        dispatch({
          type: "SAVING_GOALS",
          payload: { key: data.type, value: editedValue },
        });
      }

      if (data.type == "Amount") {
        // if (editedValue && !editedValue.includes(".")) {
        //   dispatch({
        //     type: "SAVING_GOALS",
        //     payload: { key: data.type, value: editedValue + ".00" },
        //   });
        // } else {
        //   dispatch({
        //     type: "SAVING_GOALS",
        //     payload: { key: data.type, value: editedValue },
        //   });
        // }
         const finalAmountVal = decimalValidation(editedValue)
        dispatch({
          type: "SAVING_GOALS",
          payload: { key: data.type, value: finalAmountVal },
        });
      }

      if (data.type == "Installments") {
        // if (editedValue && !editedValue.includes(".")) {
        //   dispatch({
        //     type: "ALLOCATE_FUND",
        //     payload: { key: data.type, value: editedValue + ".00" },
        //   });
        // } else {
        //   dispatch({
        //     type: "ALLOCATE_FUND",
        //     payload: { key: data.type, value: editedValue },
        //   });
        // }
        const finalInstallmentVal = decimalValidation(editedValue)
        dispatch({
          type: "ALLOCATE_FUND",
          payload: { key: data.type, value: finalInstallmentVal },
        });
      }
    }
  };

  const handleOnBlur = (event) => {
    debugger;
    if (!editedValue) {
      setError(errorMessages[data.type]);
    } else if (data.type === "Amount" && editedValue <= 0) {
      setError("Please enter amount ");
    } else if (editedValue && !editedValue.includes(".")) {
      const inputValue = event.target.value;
      const formattedAmount = handleAmountInputLimitTo2decimal(inputValue);
      // dispatch({ type: 'SAVING_GOALS', payload: { 'key': "Amount", 'value': formattedAmount.toString().replace('$', '') + '.00' } })
    } else {
      setError("");
    }
  };

  const handleOnBlurInstallment = (event) => {
    if (!editedValue) {
      setError(errorMessages[data.type]);
    } else if (data.type === "Installments" && editedValue <= 0) {
      setError("Please enter amount ");
    } else if (editedValue && !editedValue.includes(".")) {
      const inputValue = event.target.value;
      const formattedAmount = handleAmountInputLimitTo2decimal(inputValue);
      dispatch({
        type: "ALLOCATE_FUND",
        payload: {
          key: "Installments",
          value: formattedAmount.toString().replace("$", "") + ".00",
        },
      });
    } else {
      setError("");
    }
  };

  const setFrequencyFun = (value) => {
    setSelectedAccountType(value);
    dispatch({
      type: "SAVING_GOAL_ACCOUNT_TYPE_OBJ",
      payload: { savingGoalAccountTypeObj: value },
    });
  };

  return (
    <>
      {data.value && (
        <div className="flex flex-col justify-center md:mt-12 sm:mt-10 mt-12">
          {!isEditing && (
            <p
              className="pt-5 font-hanken-grotesk text-[var(--subHead-clr)] 
            uppercase lg:text-[13px] md:text-[12px] sm:text-[12px] text-[13px]
            font-[600] tracking-[2px] md:pb-8 pb-4
          "
            >
              {data.title}
            </p>
          )}
          {isEditing ? (
            <>
              {data.type === "Amount" ? (
                <CustomTextInput
                  name={t("amount")}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      event.preventDefault();
                      event.target.style.opacity = 0.8;
                      setTimeout(() => {
                        event.target.style.opacity = 1;
                      }, 200);
                    }
                  }}
                  value={editedValue}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const formattedAmount =
                      handleAmountInputLimitTo2decimal(inputValue);
                    setEditedValue(formattedAmount.toString().replace("$", ""));
                    if (!formattedAmount) setError("Enter Amount");
                    else if (inputValue <= 0) {
                      setError("Please enter amount greater than 0");
                    } else setError("");
                  }}
                  placeholder={"$ 0"}
                  onBlur={(event) => handleOnBlur(event)}
                  inputWidth="w-full"
                  error={error}
                />
              ) : data.type === "Installments" ? (
                <>
                  <CustomTextInput
                    name={t("Installments")}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        event.preventDefault();
                        event.target.style.opacity = 0.8;
                        setTimeout(() => {
                          event.target.style.opacity = 1;
                        }, 200);
                      }
                    }}
                    value={editedValue}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const formattedAmount =
                        handleAmountInputLimitTo2decimal(inputValue);
                      setEditedValue(
                        formattedAmount.toString().replace("$", "")
                      );
                      if (!formattedAmount) {
                        setError("Enter Installments");
                      } else if (parseFloat(formattedAmount) <= 0) {
                        setError("Please enter Installments greater than 0");
                      } else if (parseFloat(formattedAmount) > parseFloat(savingsGoalAmount)) {
                        setError(t("The_fund_amount_should_be_less"));
                      } else {
                        setError("");
                      }
                    }}
                    placeholder={"$ 0"}
                    onBlur={(event) => handleOnBlurInstallment(event)}
                    inputWidth="w-full"
                    error={error}
                  />
                </>
              ) : data.type === "Frequency" ? (
                <CustomDropdown
                  isScroll={false}
                  options={frequecyDataGetting}
                  title="FREQUENCY"
                  onSelect={(option) => {
                    dispatch({
                      type: "SELECTED_FREQUENCY_VALUE",
                      payload: { selectedFrequencyValue: option },
                    });
                    setEditedValue(option.DisplayText);
                  }}
                  selectedFrequency={editedValue}
                  error={error}
                />
              ) : data.type === "AccountsType" ? (
                <CustomAllocateFundDropdown
                  isScroll={false}
                  options={accountObj}
                  title="Account"
                  onSelect={setFrequencyFun}
                  selectedFrequency={editedValue}
                  selectedAccountType={selectedAccountType}
                  error={error}
                />
              ) : data.type === "StartDate" ? (
                <>
                  <CustomDatePicker
                    selectedDate={data.value}
                    onDateChange={(date) => setEditedValue(date)}
                    minDate={new Date(new Date().toUTCString().substr(0, 25))}
                    // minDate={new Date()}
                    //maxDate={''}
                    placeHolder={"Select Date"}
                    disabledDates={[]}
                    title="Start"
                    hrbg="bg-dropdown-sky"
                  />
                  <div>{error}</div>
                </>
              ) : data.type === "Name" ? (
                <>
                  <CustomTextInput
                    name={"Savings Goal"}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        event.preventDefault();
                        event.target.style.opacity = 0.8;
                        setTimeout(() => {
                          event.target.style.opacity = 1;
                        }, 200);
                      }
                    }}
                    value={editedValue}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      setEditedValue(inputValue);
                      if (!inputValue) setError("Enter Savings Goal");
                      else if (inputValue <= 0) {
                        setError("Please enter Savings Goal");
                      } else setError("");
                    }}
                    placeholder={"Name"}
                    onBlur={(event) => handleOnBlur(event)}
                    inputWidth="w-full"
                    error={error}
                  />
                </>
              ) : null}
              <p
                className="pt-5 font-hanken-grotesk font-[700] cursor-pointer text-[var(--dynamic-save-clr)] lg:text-[16px] md:text-[15px] 
 sm:text-[13px] text-[13px]
 "
                onClick={() => {
                  if (!error) {
                    handleSave();
                  }
                }}
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSave();
                }}
              >
                {t("save")}
              </p>
            </>
          ) : (
            <>
              <p
                className="md:mb-6 mb-2 flex flex-row justify-between font-hanken-grotesk font-[700] lg:text-[16px] md:text-[15px] sm:text-[13px] 
 text-[14px] text-[var(--pin-clr)]"
              >
                {data.title === "Amount" ? `$ ${data.value}` : data.value}
                {data.title === "Start" && (
                  <img
                    src={appThemeData.callAcc}
                    alt="Calender"
                    className="w-3 h-3 mr-2 ml-10"
                  />
                )}
              </p>
              <hr className="h-[2px] bg-[var(--hr-color)] border-0 rounded" />
              <p
                className="pt-5 font-hanken-grotesk font-[700] cursor-pointer text-[var(--buttons-clrs)] lg:text-[16px] md:text-[15px] 
                sm:text-[13px] text-[13px]
                "
                onClick={() => setIsEditing(true)}
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter") setIsEditing(true);
                }}
              >
                {data.edit}
              </p>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default AllocateFundSubItemConfirmationCard;
